import React from "react";
import { Modal, Button } from "react-bootstrap";

const ApprovePaymentModal = ({
  show,
  onClose,
  amount,
  invoiceNo,
  onConfirm,
  loading,
  approveError,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="text-success">
          Confirm Payment Approval
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        <div className="mb-3">
          <i
            className="fa fa-check-circle text-success"
            style={{ fontSize: "48px" }}
          ></i>
        </div>

        <p className="fw-semibold mb-1">
          Are you sure you want to approve this payment?
        </p>

        <p className="text-muted mb-0">
          Amount: <strong>₹ {amount}</strong> <br />
          Invoice: <strong>{invoiceNo}</strong>
        </p>

        <p className="text-danger small mt-2">This action cannot be undone.</p>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <Button variant="outline-secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="success" onClick={onConfirm} disabled={loading}>
          {loading ? "Approving..." : "Yes, Approve"}
        </Button>
        {approveError && `Something Went Wrong. ${approveError}`}
      </Modal.Footer>
    </Modal>
  );
};

export default ApprovePaymentModal;
